import { buildInvoiceLineItems } from "./invoiceLineItems";
import { getSenderProfile } from "./invoiceSenderProfile";
import {
  getCurrencyInfo,
  getHourlyRate,
  getAiHourlyRate,
  isAiInvoiceEnabled,
} from "./billingRateSetting";

/** The client doc linked to an invoice (or null). Matches on numeric id. */
export function clientForInvoice(invoice, clients) {
  return clients.find((c) => Number(c.id) === Number(invoice.clientId)) || null;
}

/**
 * Assemble the data object generateInvoicePdf() needs from a stored invoice:
 * sender profile + currency/rates from settings, the linked client, and line
 * items recomputed from time records (same math as Android).
 */
export function buildInvoicePdfData(invoice, { clients = [], tasks = [], projects = [], timeRecords = [] }) {
  const sender = getSenderProfile();
  const currency = getCurrencyInfo();
  const humanRate = getHourlyRate();
  const aiRate = isAiInvoiceEnabled() ? getAiHourlyRate() : 0;
  const client = clientForInvoice(invoice, clients) || {};
  const lineItems = buildInvoiceLineItems({
    timeRecords,
    tasks,
    projects,
    projectIds: invoice.projectIds || [],
    periodStart: invoice.periodStart,
    periodEnd: invoice.periodEnd,
    humanRate,
    aiRate,
  });
  return {
    sender,
    client: {
      name: client.name || "",
      address: client.address || "",
      taxId: client.taxId || "",
    },
    invoiceNumber: invoice.number,
    issueDate: invoice.issueDate,
    dueDate: invoice.dueDate,
    lineItems,
    taxRatePercent: invoice.taxRatePercent || 0,
    notes: invoice.notes || "",
    currency: { symbol: currency.symbol, code: currency.code },
  };
}
